import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, FormControlLabel, Switch } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import { domainName, portal_config } from '../../../portal.config';
import { getAppCfg } from '../../utils/common';
import countries from '../../../countries';
import { InformPasswordIcon } from '../../components/icons';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const MIN_LENGTH_PASSWORD = 8;

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginTop2x: {
        marginTop: theme.spacing(10),
    },
    marginTop4x: {
        marginTop: theme.spacing(20),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 10, 15),
    },
    form_select:{
        marginTop: theme.spacing(4),
        cursor: 'pointer'
    },
    swichSmall: {
        marginTop: theme.spacing(2),
        resizeMode: 'contain',
        cursor: 'pointer'
    },
    inform: {
        cursor: 'pointer',
    },
    inform_password: {
        position: 'relative',
    },
    inform_password_desc: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.secondary,
        // marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: '1px solid ' + theme.palette.border.secondary,
        position: 'absolute',
        zIndex: 10,
    },
});
function CredentialsView(props){
    const { classes, t, showAlert, onShowLoading, register_info, onSelectMethod, onSelectVerify } = props;
    const [showInform, setShowInform] = useState(false);
    //console.log('RegisterEmailView auth_support==',auth_support)
    const config = getAppCfg()
    const str = config.auth_support&&config.auth_support.email_password?t('auth_credentinal_email'):t('auth_credentinal_phone')
    return (
        <PublicPage 
            rightComponent={
                <Grid xs={12} sm={12} md={12} item container>
                    <Grid xs={12} sm={12} item container>
                        <Typo variant='h3' color={domainName =='buyway' ? 'onPrimary' : 'primary'} mg_bottom_md>{t('hello_title')+" "+props.contact}</Typo>
                    </Grid>
                    <Grid xs={12} item container direction="row">
                        <Typo variant='body2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} >{t('auth_credentinal')}{str}{t('auth_credentinal_2')}{portal_config[domainName].app_name}{"."}</Typo>
                    </Grid>
                    <Grid xs={12} sm={12} item container justify='center'>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit, reset, submitting, pristine, values }) => (
                            <Grid xs={12} container item className={classes.marginTop}>

                               {config.auth_support&&config.auth_support.email_password?<Grid item container>

                                <Field
                                    name="EMAIL"
                                    label={t('email')}
                                    component={TextFieldComponent}
                                    placeholder={t('email_input_placeholder')}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.validEmail)}
                                    autoFocus={true}
                                />
                                 <Field
                                    name="password"
                                    component={TextFieldComponent}
                                    customLabel={true}
                                    label={<Grid item xs={12} container className={classes.inform} onMouseEnter={()=> setShowInform(true)} onMouseLeave={()=> setShowInform(false)}>
                                        <Typo mg_left_md variant="input_label" color="default">{t('password')}</Typo>
                                        <Grid item style={{marginLeft: 10}}><InformPasswordIcon /></Grid>
                                    </Grid>}
                                    placeholder={t('enter_your_password')}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.required, validators.validMinLength(MIN_LENGTH_PASSWORD))}
                                    autoFocus={true}
                                    type='password'
                                />
                                {showInform && <Grid item xs={12} className={classes.inform_password}>
                                    <Grid item className={classes.inform_password_desc}>
                                        <Typo color='error'>{t('inform_password')}</Typo>
                                        <Typo color='error'>{t('inform_password_1')}</Typo>
                                        <Typo color='error'>{t('inform_password_2')}</Typo>
                                        <Typo color='error'>{t('inform_password_3')}</Typo>
                                        <Typo color='error'>{t('inform_password_4')}</Typo>
                                        {/* <Typo color='error'>{t('inform_password_5')}</Typo> */}
                                    </Grid>
                                </Grid>}
                                <Field
                                    name="confirm_password"
                                    component={TextFieldComponent}
                                    label={t('confirm_password')}
                                    placeholder={t('confirm_password_placeholder')}
                                    isEdit={true}
                                    color='default'
                                    //validate={validators.composeValidators(validators.required)}
                                    autoFocus={true}
                                    type='password'
                                    validate={validators.composeValidators(validators.validNotMatch({compareValue: values.password, message: t('enter_same_password')},values.confirm_password))}
                                />
                                </Grid>:<Grid item container>
                                    <Field
                                        name="PHONE"
                                        label={t('phone_number')}
                                        component={TextFieldWithSelectComponent}
                                        isEdit={true}
                                        validate={validators.composeValidators(validators.mustBeNumber)}
                                        autoFocus={true}
                                        selectData={countries}
                                        defaultValueSelect={props.country_select}
                                        valueSelect={props.country_select}
                                        onSelectedChange={props.onSelectCountry}
                                    />
                                    </Grid>}
                                <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                                    <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_register')}</Button>
                                </Grid>
                            </Grid>
                        )} />
                    </Grid>
                </Grid>}
        />
    );
}
export default withStyles(styles)(withTranslation()(CredentialsView));